import { FileViewerTrackingContext, ViewMode } from "fond/widgets/FilesViewer/types";

import { event, number, oneOf } from "../schema-util";

const baseFileViewerEvent = event({
  view: oneOf(ViewMode),
  context: oneOf(FileViewerTrackingContext).optional().describe("The context in which the file viewer is being used"),
});

export const fileViewer = {
  "file-viewer.file.preview.opened": baseFileViewerEvent.extend({
    index: number().describe("The index of the file being previewed"),
  }),
  "file-viewer.file.preview.closed": baseFileViewerEvent.extend({
    index: number().describe("The index of the file being closed"),
  }),
};
